import { render, staticRenderFns } from "./nomal_note.vue?vue&type=template&id=13466728&scoped=true"
import script from "./nomal_note.vue?vue&type=script&lang=js"
export * from "./nomal_note.vue?vue&type=script&lang=js"
import style0 from "./nomal_note.vue?vue&type=style&index=0&id=13466728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13466728",
  null
  
)

export default component.exports